import type { ReactElement } from 'react';
import { Navigate, useParams } from 'react-router';
import { GetStartedPage } from './GetStartedPage';
import { McpDocsPage } from './McpDocsPage';
import { RequestAccessDocsPage } from './RequestAccessDocsPage';
import { AgentsDocsPage } from './AgentsDocsPage';

/**
 * Unified documentation surface. This is an AI-agent-first system, so the docs
 * — Get Started (connect an agent), how to request access, and the MCP tool
 * reference — are grouped under one /docs route. The section menu lives in the
 * app's left sidebar (App.tsx); this component just renders the active section.
 * Section metadata (slugs/labels) is shared via lib/docs → DOC_SECTIONS.
 */
const ELEMENTS: Record<string, ReactElement> = {
  'get-started': <GetStartedPage />,
  'request-access': <RequestAccessDocsPage />,
  mcp: <McpDocsPage />,
  agents: <AgentsDocsPage />,
};

export function DocsPage() {
  const { section } = useParams();
  const el = section ? ELEMENTS[section] : undefined;
  if (!el) return <Navigate to="/docs/get-started" replace />;

  // .docs-content scopes the docs reading-column styling (globals.css).
  return <div className="docs-content">{el}</div>;
}
